// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd2181f2","453":"a3573bf2","455":"53a5cb8d"}[chunkId] + ".chunk.js";
};